import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import numeral from 'numeral';
import moment from 'moment';

import { HorizontalBar, Line } from 'react-chartjs-2';

import { listRevenue, loadRevenueReports, loadMCIReports } from '../../actions/reports';
import { DateRange, getDateRange } from '../../components/DateRange';

import BlankState from '../../components/BlankState';
import Page from '../../components/Page';
import Panel from '../../components/Panel';
import Utils from '../../utils/mci-utils';

const time_sections = {
	DAILY: 'daily',
	WEEKLY: 'weekly',
	MONTHLY: 'monthly',
	YEARLY: 'yearly',
	SECTIONS: 'sections',
};

class Revenue extends Component{

	constructor(props){
		super(props);

		this.state = {
			revenue: {},
			mciData: {},

			filter: {
				type: time_sections.DAILY
			},
			date_range: ''
		};
	}

	componentDidMount() {
		this.buildRevenueChart();
	}

	componentWillReceiveProps(nextProps){
		console.log(nextProps);
		const { revenue_summary, mci } = nextProps.reports;

		this.setState({ 
			revenue : revenue_summary,
			mciData : mci
		});
	}

	buildRevenueChart = () => {
		const { filter, date_range } = this.state;

		this.props.loadRevenueReports(date_range);
		this.props.loadMCIReports(filter, date_range);
	}

	prepareChartData(collection){
		let labels = [], data1 = [], data2 = [], data3 = [];

		const { filter } = this.state;

		for(let i in collection){
			

			switch (filter.type) {
				
				case time_sections.DAILY:
					labels.push(collection[i].date);
					break;
				
				case time_sections.WEEKLY:
					labels.push(collection[i].date_from);
					break;

				case time_sections.MONTHLY:
					labels.push(collection[i].month_name);
					break;
				
				case time_sections.YEARLY:
					labels.push(collection[i].year);
					break;
			
				case time_sections.SECTIONS:
					labels.push(collection[i].section_name);
					break;
				
				default:
					labels.push(collection[i].date);
					break;
			}
			
			data1.push(collection[i].totals.premium);
			data2.push(collection[i].totals.cfr);
			data3.push(collection[i].totals.suminsured);
		}

		labels.reverse();
		data1.reverse();
		data2.reverse();
		data3.reverse();

		return { labels, data1, data2, data3 };
	}

	buildRevenueData(data){
		const { collection } = data || {};

		let chartData = this.prepareChartData(collection);

		return {
			labels: chartData.labels,
			datasets: [
				{
					label: 'Premiums',
					data: chartData.data1,
					borderColor: "#FF6384",
					backgroundColor: "#FF6368",
					hoverBackgroundColor: "#FF6368",
					borderWidth: 2,
					fill: false
				},
				{
					label: 'CFR',
					data: chartData.data2,
					borderColor: "#3bb95f",
					backgroundColor: "#3BB95F",
					hoverBackgroundColor: "#3BB95F",
					borderWidth: 2,
					fill: false
				},
				{
					label: 'Sum Insured',
					data: chartData.data3,
					borderColor: "#b93b56",
					backgroundColor: "#B93B56",
					hoverBackgroundColor: "#B93B56",
					borderWidth: 2,
					fill: false,
					borderDash: [5, 5]
				}
			]
		};
	}
	
	toggleDatePicker = (e) => {
		this.setState({ show_custom_ranges: e.target.checked });
	}

	onChange = (e) => {
		e.preventDefault();

		const { name, value } = e.target;

		this.setState({
			filter: {
				[name]: value
			}
		}, ()=>{
			this.buildRevenueChart();
		});
	}

	onChangeDateRange = (e) => {
		// e.preventDefault();
		console.log(e.target.name, e.target.value);

		let range = getDateRange(e.target.value);

		if(range.hasOwnProperty('start_date')){

			// Difference in days to determine range type to use
			let diff = moment(range.end_date).diff(moment(range.start_date), 'days'),
				filterType = time_sections.DAILY;

			if(diff <= 31){
				filterType = time_sections.DAILY;
			}
			else if(diff > 31 && diff <= 93){
				filterType = time_sections.WEEKLY;
			}
			else if(diff > 31 && diff <= 366){
				filterType = time_sections.MONTHLY;
			}
			
			this.setState({
				date_range: range,
				filter: { type: filterType }
			}, ()=>{
				this.buildRevenueChart();
			});
		}
	}
	
	render(){
		const { filter, show_custom_ranges, mciData} = this.state;

		console.log(this.props.reports);

		const { reports } = this.props;

		let sumInsured = reports.revenue_summary.overall_totals ? reports.revenue_summary.overall_totals.suminsured : null;
		let totalCfr = reports.revenue_summary.overall_totals ? reports.revenue_summary.overall_totals.cfr : null;
		let totalPremium = reports.revenue_summary.overall_totals ? reports.revenue_summary.overall_totals.premium : null;

		const { today, last_7days, last_30days, last_3months, last_12months } = Utils.getTimeRanges();

		let data = {
			labels: ["Total Sum Insured", "Total CFR", "Total Premium"],
			datasets: [{
				label: 'Total Sum Insured, Total CFR, Total Premiums Levels',
				data: [
					sumInsured, 
					totalCfr, 
				    totalPremium
				],
				backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
				hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56']
			}]
		}

		const {
			mci_loading,
			revenue_summary_loading,
		} = this.props.reports;
		
		return(
			<Page isAdminPage={ true } pageTitle="Revenue">
				<div className="clearfix">
					<div className="btn-group clearfix">
						<label className="btn-radio">
							<input type="radio" name="range" 
								value={ today + ' - ' + today } 
								onChange={ this.onChangeDateRange } defaultChecked />
							<span>Today</span>
						</label>

						<label className="btn-radio">
							<input type="radio" name="range" 
								value={ last_7days }
								onChange={ this.onChangeDateRange } />
							<span>Last 7 days</span>
						</label>

						<label className="btn-radio">
							<input type="radio" name="range" 
								value={ last_30days } 
								onChange={ this.onChangeDateRange } />
							<span>Last 30 days</span>
						</label>

						<label className="btn-radio">
							<input type="radio" name="range" 
								value={ last_3months }
								onChange={ this.onChangeDateRange } />
							<span>Last 3 months</span>
						</label>

						<label className="btn-radio">
							<input type="radio" name="range" 
								value={ last_12months } 
								onChange={ this.onChangeDateRange } />
							<span>Last 12 months</span>
						</label>

						<label className="btn-radio" htmlFor="custom_range">
							<input type="radio" id="custom_range" name="range" 
								onChange={ this.toggleDatePicker } />
							<span>Custom</span>
						</label>

						<div className="clearfix">
						{
							show_custom_ranges ? 
								<DateRange 
									name="date_range" 
									onChange={ this.onChangeDateRange } />
							: 
								null
						}
						</div>
					</div>
				</div>

				<div className="card report-charts" style={{ height:'450px', overflow:'hidden' }}>

					<BlankState 
						data={ false }
						isDataLoading={ revenue_summary_loading }
						customMessage="Loading revenue summary" />

					<Panel title="Total Revenues">
						<HorizontalBar 
							data={ data }
							height={ 250 }
							options={{
								scales: {
									xAxes: [{
										ticks: {
											callback: function (value, index, values) {
												return numeral(value / 1E6).format('0,0') + ' M';
											},
											beginAtZero: true
										}
									}],
									yAxes: [{
										ticks: {
											beginAtZero: true
										}
									}]
								},
								responsive: true,
								maintainAspectRatio: false,
								legend: { display: false }
							}} />
					</Panel>
				</div>

				<div className="card report-charts" style={{ height:'400px', overflow:'hidden' }}>
					<BlankState 
						data={ false }
						isDataLoading={ mci_loading }
						customMessage="Loading revenue reports" />
					
					<Line 
						data={ this.buildRevenueData(mciData) }
						height={ 360 }
						options={{
							scales: {
								xAxes: [{
									ticks: {
										callback: function (value, index, values) {
											if(filter.type === time_sections.MONTHLY){
												return value;
											}
											else{
												return moment(value).format("MMM Do");
											}
										},
										fixedStepSize: 50,
										beginAtZero: true
									}
								}],
								yAxes: [{
									ticks: {
										beginAtZero: true,
										callback: function(label, index, labels) {
											if (Math.floor(label) === label) {
												return numeral(label).format('0,0');
											}
										}
									}
								}]
							},
							maintainAspectRatio: false
						}} />
				</div>

				<div className="col-sm-6 hidden">
					<Panel title="Branch Premiums">
						
					</Panel>
				</div>
			</Page>
		);
	}
}

const mapStateToProps = (state,ownProps) => ({
	user: state.user,
	reports: state.reports
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ listRevenue, loadRevenueReports, loadMCIReports }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Revenue);


// WEBPACK FOOTER //
// ./src/pages/dashboard/Revenue.jsx